<template>
  <div class="columns">
    <div class="column is-one-quarter">
      <StepProgressBar />
    </div>
    <div class="column" :class="{
        'content' : $route.name !== 'courses',
        'bg-1' : $route.name !== 'contract' && $route.name !== 'training', 
        'bg-2' : $route.name === 'contract',
        'courses' : $route.name === 'courses'}">
      <router-view></router-view>
    </div>
   
  </div>
</template>
<script>
import StepProgressBar from "@/components/StepProgressBar.vue";
import { mapGetters } from "vuex"
export default {
  components: {
    StepProgressBar,
  },
  computed : {
    ...mapGetters(['supplierToken', "isLoadingProfile"]),
    isMobile() {
      return screen.width < 768
    }
  },
};
</script>
<style lang="scss" scoped>
.column {
  padding: 0;
}
.columns{
  margin: 0 !important;
  position: relative;
}

.content{
  padding: 50px 0 0 50px;
  max-height: 100vh;
  overflow-y: scroll;
  position: relative;
}
.courses {
  max-height: 100vh;
  overflow-y: scroll;
  position: relative;
}
.content::-webkit-scrollbar{
  display: none;
}
.content.bg-1{
   background-image: url('/img/onboard-driver/bg-wave.svg');
    background-repeat: no-repeat;
    background-position: bottom center;
    background-size: contain;
    height: 100vh;
}
.content.bg-2{
   background-image: url('/img/onboard-driver/bg-contract.svg');
    background-repeat: no-repeat;
    background-position: bottom center;
    background-size: contain

}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .content{
    max-width: 100vh;
    padding: 20px;
  }

  .content.courses {
    padding: 0;
  }

  .pop-up__openApp{
    width: 320px;
  }
}
</style>